import React, { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import i18n from "./../i18n";
import "../styles/heroes.css";
import "../styles/carousel.scss";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import recipePageImage from "../resources/recipe-page-light-small.png";
// import recipePageImageDark from "../resources/recipe-page-dark-small.png";
import recipeSearchImage from "../resources/recipe-search-window-small.png";
import recipeSearchImageDark from "../resources/recipe-search-window-dark-small.png";
// import youTubeImage from "../resources/youtube-channel-promo-light-small.png";
// import youTubeImageDark from "../resources/youtube-channel-promo-dark-small.png";
import Pricing from "../components/pricing/Pricing";
// import { Footer } from "../components/main/Footer";
import MetaTags from "../components/seo/MetaTags";
import { Helmet } from "react-helmet";
import CarouselItem from "../components/main/CarouselItem.js";
import NewsletterSignup from "../components/navbar/action-forms/NewsletterSignup";

function Home(props) {
  const [carouselItems, setCarouselItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useNavigate();

  // Fetch carousel first
  useEffect(() => {
    const fetchCarousel = async () => {
      try {
        const apiUrl = process.env.REACT_APP_WP_API_IP + "/carousel/v1/items";
        const res = await fetch(apiUrl);
        const data = await res.json();

        const items = Array.isArray(data)
          ? data
          : Array.isArray(data?.items)
          ? data.items
          : []; // fallback empty array

        setCarouselItems(items);
      } catch (err) {
        console.error("Failed to fetch carousel items:", err);
        setCarouselItems([]); // fallback safe
      } finally {
        setLoading(false);
      }
    };

    fetchCarousel();
  }, []);

  //Only trigger animations AFTER carousel is loaded
  useEffect(() => {
    if (loading) return; // don’t run until carousel loaded

    const observerLeft = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const slide = entry.target.querySelector(".animate-slide-in-left");
        if (slide && entry.isIntersecting) {
          slide.classList.add("left-slide");
        }
      });
    });

    const observerRight = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const slide2 = entry.target.querySelector(".animate-slide-in-right");
        if (slide2 && entry.isIntersecting) {
          slide2.classList.add("right-slide");
        }
      });
    });

    const leftEl = document.querySelector(".animate-wrapper-left");
    const rightEl = document.querySelector(".animate-wrapper-right");
    const left2El = document.querySelector(".animate-wrapper-left2");

    if (leftEl) observerLeft.observe(leftEl);
    if (process.env.REACT_APP_PRODUCT_LAUNCH === "true" && left2El)
      observerLeft.observe(left2El);
    if (process.env.REACT_APP_PRODUCT_LAUNCH === "false" && rightEl)
      observerRight.observe(rightEl);

    return () => {
      observerLeft.disconnect();
      observerRight.disconnect();
    };
  }, [loading]);

  const loginPage = () => history("/login");
  const youTubePage = () =>
    window.open("https://www.youtube.com/@AndrewsCookin");

  // 🧠 While loading carousel, show a placeholder
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // 🧱 Once carousel loaded, render rest of page
  return (
    <div role="main" className="mx-8 flex flex-col min-h-screen">
      <div className="flex-grow">
        <MetaTags
          name="description"
          content={i18n.t("landingPage_description")}
        ></MetaTags>
        <Helmet>
          <title>No Bulls**t Recipes | Andrew's Cookin'</title>
          <link rel="canonical" href="https://www.andrewscookin.com"></link>
        </Helmet>

        {props.user && props.firstTime && <Navigate to={"/recipe-search"} />}

        {/* ✅ Carousel is ready before rest renders */}
        <div id="carousel-background">
          <div id="myCarousel" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-indicators">
              {carouselItems.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  data-bs-target="#myCarousel"
                  data-bs-slide-to={idx}
                  className={idx === 0 ? "active" : ""}
                  aria-current={idx === 0 ? "true" : undefined}
                  aria-label={`Slide ${idx + 1}`}
                ></button>
              ))}
            </div>
            <div className="carousel-inner">
              {carouselItems.map((item, idx) => (
                <CarouselItem
                  key={idx}
                  active={idx === 0}
                  title={item.title || i18n.t("landingPage_carousel_title_1")}
                  description={
                    item.description ||
                    i18n.t("landingPage_carousel_description_1")
                  }
                  link={item.link || "/recipes"}
                  image={item.image || "https://i.imgur.com/rqssuhUl.jpeg"}
                />
              ))}
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#myCarousel"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#myCarousel"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        {process.env.REACT_APP_PRODUCT_LAUNCH === "false" && (
          <div>
            <hr className="featurette-divider"></hr>
            {/* Recipe Search Tool */}
            <div className="animate-wrapper-right">
              <div className="row featurette animate-slide-in-right">
                <div className="order-md-1">
                  <h2
                    className="featurette-heading"
                    style={{ marginTop: "0px" }}
                  >
                    A.I. Powered{" "}
                    <span className="text-muted">Recipe Search Tool</span>
                  </h2>
                  <p className="lead">Coming Soon...</p>
                 
                </div>
                <div className="col-md-5 order-md-1 crop border border-gray-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
                  <NewsletterSignup />
                   <small>
                    Joking, there will be no A.I. Only <b>REAL</b> Recipes
                  </small>
                </div>
              </div>
            </div>
          </div>
        )}
        <hr className="featurette-divider"></hr>

        {/* YouTuber thingy */}
        <div className="animate-wrapper-left">
          <div className="row featurette animate-slide-in-left">
            <div className="col-md-7">
              <h2 className="featurette-heading">
                Straight from{" "}
                <span className="text-muted">
                  {" "}
                  Andrew's Cookin' YouTube channel.
                </span>
              </h2>
              <p className="lead">
                This Website is Full of Tested Recipes everyone Will Enjoy! No
                Bullsh*t!
              </p>
            </div>
            <div className="col-md-5 crop">
              <picture>
                <source
                  className="cursor-pointer"
                  srcSet="https://i.imgur.com/s22GcwAl.png"
                  media="(prefers-color-scheme: dark)"
                ></source>
                <img
                  onClick={youTubePage}
                  className="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto remove-img-in-responsive cursor-pointer"
                  width="500px"
                  height="500px"
                  alt="Image of Andrew's Cookin' YouTube Channel"
                  src="https://i.imgur.com/kl9SaOXl.png"
                ></img>
              </picture>
            </div>
          </div>
        </div>
        
        {process.env.REACT_APP_PRODUCT_LAUNCH === "true" && (
          <div>
            <hr className="featurette-divider" id="demo"></hr>
            {/* Allrecipe */}
            <div className="animate-wrapper-right">
              <div className="row featurette  animate-slide-in-right">
                <div className="col-md-7 order-md-2">
                  <h2 className="featurette-heading">
                    Oh yeah, it’s that good.{" "}
                    <span className="text-muted">See for yourself.</span>
                  </h2>
                  <p className="lead">
                    Infinate amount of recipes for you to Try and Enjoy!
                  </p>
                </div>
                <div className="col-md-5 order-md-1 crop">
                  {/* <img
                className="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto remove-img-in-responsive"
                width="500px"
                height="500px"
                alt=""
                src={recipesImage}
              ></img> */}
                  <iframe
                    className="mx-auto remove-img-in-responsive"
                    width="650"
                    height="366"
                    // src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1&controls=0&loop=1"
                  ></iframe>
                </div>
              </div>
            </div>
            <hr className="featurette-divider"></hr>
            {/* kuky thingy */}
            <div className="animate-wrapper-left2">
              <div className="row featurette animate-wrapper-left animate-slide-in-left">
                <div className="col-md-7">
                  <h2 className="featurette-heading">
                    Use intricate features.{" "}
                    <span className="text-muted">
                      Customize your recipe Search!
                    </span>
                  </h2>
                  <p className="lead">
                    Use Filters, Pantry features and so much More! Pick your
                    Diet and find a Random recipe you might enjoy. Fill in a
                    questionaire, pick a Cuisine, the possibilities are ENDLESS!
                  </p>
                </div>
                <div className="col-md-5 crop">
                  <picture>
                    <source
                      srcSet={recipeSearchImageDark}
                      media="(prefers-color-scheme:dark)"
                    ></source>
                    <img
                      className="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto remove-img-in-responsive"
                      width="500"
                      height="500"
                      alt="Recipe Search Application Image"
                      src={recipeSearchImage}
                    ></img>
                  </picture>
                </div>
              </div>
            </div>
          </div>
        )}

        {process.env.REACT_APP_PRODUCT_LAUNCH === "true" && (
          <div>
            <hr className="featurette-divider" id="pricing"></hr>
            <Pricing email={props.user}></Pricing>
          </div>
        )}
        <hr className="featurette-divider"></hr>
        {/* </div> */}
        {/* <Footer /> */}
      </div>
    </div>
  );
}
export default Home;
